// extracted by mini-css-extract-plugin
module.exports = {"formItem-wrapper":"formItem-wrapper--1GX9EBn9"};